module.exports = __webpack_public_path__ + "media/images/flags/SY-f879af615a382a15d342da8500359d62.svg";